var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSkipRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2.75C11.9999 2.33579 11.6641 2 11.2499 2C10.8357 2 10.4999 2.33579 10.4999 2.75V13.25C10.4999 13.6642 10.8357 14 11.2499 14C11.6641 14 11.9999 13.6642 11.9999 13.25V2.75Z",
    fill: "#80959D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86447 14.0425C2.56485 13.7565 2.55381 13.2818 2.83981 12.9821L7.43072 8.17262C7.52293 8.07601 7.52293 7.92399 7.43072 7.82738L2.83981 3.01786C2.5538 2.71823 2.56485 2.24349 2.86447 1.95748C3.16409 1.67148 3.63884 1.68252 3.92484 1.98214L8.51575 6.79167C9.16126 7.46791 9.16126 8.53209 8.51575 9.20833L3.92484 14.0179C3.63884 14.3175 3.16409 14.3285 2.86447 14.0425Z",
    fill: "#80959D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkipRightArrow);
export default __webpack_public_path__ + "static/media/icon-skip-right-arrow.557de15ba2f6a3735194fb9d756c6eab.svg";
export { ForwardRef as ReactComponent };